<template>
  <div>
    <v-row>
      <v-col :cols="displayColumns" v-if="isInitial || isSaving || multiple">
        <form enctype="multipart/form-data" novalidate>
          <div class="dropbox">
            <input
              ref="fileUpload"
              type="file"
              :multiple="multiple"
              :name="uploadFieldName"
              :disabled="isSaving"
              @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"
              :accept="accept"
              class="input-file"
            />
            <div class="text-center" style="padding-top: 10px">
              <v-icon x-large>mdi-cloud-upload-outline</v-icon>
            </div>

            <p v-if="!isSaving">Arraste o arquivo do recibo ou clique para procurar</p>
            <p v-if="isSaving">{{ $vuetify.lang.t('$vuetify.uploading') }}</p>
            <h4 class="text-center" v-if="displayWH">{{ displayWH }}</h4>
            <h4 class="text-center" v-if="displaySize">{{displaySize}}</h4>
          </div>
        </form>
      </v-col>

      <!-- <v-col :cols="displayColumns" :key="item.id || item.url" v-for="item in uploadedFiles">
        <v-img contain :src="getUrlImage(item.url)" :alt="item.name" max-height="200">
          <div class="text-right">
            <v-btn
              @click="deleteImage(item)"
              text
              icon
              color="nav"
              :alt="$vuetify.lang.t('$vuetify.remove')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-img>
      </v-col>-->      
      <v-col :cols="displayColumns" :key="item.id || item.url" v-for="item in uploadedFiles">
        <v-img v-if="!showAsList" contain :src="getUrlImage(item.url)" :alt="item.name" max-height="200" >
          <div class="text-right">
            <v-btn
              @click="deleteImage(item)"
              text
              icon
              color="nav"
              :alt="$vuetify.lang.t('$vuetify.remove')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-img>
        <v-card v-else color="secondary" dark >
          <v-card-actions>
            <span v-if="isBase64(item.url)">{{item.nome}}</span>
            <v-btn text @click="openImage(item)" v-if="!isBase64(item.url)">
              <v-icon left>mdi-file-pdf</v-icon>Visualizar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="deleteImage(item)">
              <v-icon left>mdi-trash-can-outline</v-icon>Remover
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <div v-if="isFailed">
      <h2>{{$vuetify.lang.t('$vuetify.uploadError')}}</h2>
      <p>
        <a href="javascript:void(0)" @click="reset()">{{$vuetify.lang.t('$vuetify.tryAgain')}}</a>
      </p>
      <pre>{{ uploadError }}</pre>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { uploadFake } from "../../plugins/fileupload";
import AlertType from "../../utils/alertType";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: "FileUpload",
  data() {
    return {
      imageId: 0,
      //uploadedFiles: [],
      uploadError: null,
      fileUploadMessages: [],
      currentStatus: null,
      uploadFieldName: "photos"
    };
  },
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    showAsList: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: undefined
    },
    width: {
      type: Number,
      default: undefined
    },
    size: {
      type: Number,
      default: undefined
    },
    columns: {
      type: Number,
      default: undefined
    },
    file: {
      type: [Array, Object, String],
      default: undefined,
      required: true
    }
  },
  watch: {
    file(newValue, oldValue) {
      if (typeof newValue.id === "number" && newValue.id === 0)
        this.imageId = 0;
    }
  },
  computed: {
    accept() {
      if (this.showAsList)
        return "application/pdf, image/*";

      return "image/*";
    },
    displayWH() {
      if (this.width && this.height) return this.width + " x " + this.height;
      return null;
    },
    displaySize() {
      if (this.size) return "Tamanho Máx: " + this.size + " MB";
      return null;
    },
    displayColumns() {
      if (this.columns) return this.columns;

      if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
        return 3;
      } else if (this.$vuetify.breakpoint.md) {
        return 4;
      } else if (this.$vuetify.breakpoint.sm) {
        return 6;
      } else {
        return 12;
      }
    },
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
    uploadedFiles: {
      get() {        
        if (this.file.url || this.file.length > 0) {
           if (
             this.file.id > 0 ||
             (this.file.length > 0 && this.file.every(x => x.id > 0))
           ) {
             if (typeof this.file === "object" && !this.multiple)
               this.imageId = this.file.id;
           }
          this.currentStatus = STATUS_SUCCESS;
          return this._.concat(this.file);
        }

        this.currentStatus = STATUS_INITIAL;
        return [];
      },
      set(val) {        
        let files = null;
        if (val.length) {
          files = this.multiple ? val : this._.first(val);
          if (!this.multiple && this.imageId > 0) files.id = this.imageId;
        } else {
          files = this.multiple ? [] : {};
        }

        this.$emit("update:file", files);
      }
    }
  },
  methods: {
    getUrlImage(url) {
      if (url.startsWith("data:image") || url.startsWith("data:application"))
        return url;

      return this.$app.api + url;
    },
    deleteImage(img) {
      this._.remove(this.uploadedFiles, x => x.url === img.url);
      if (!this.multiple || !this.uploadedFiles.length) this.reset();
      else this.uploadedFiles = this._.concat(this.uploadedFiles);

      //this.update();
    },   
    reset() {
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(formData) {
      this.currentStatus = STATUS_SAVING;
      uploadFake(formData)
        .then(x => {          
          this.uploadedFiles = this._.concat(this.uploadedFiles, x);
          this.currentStatus = STATUS_SUCCESS;
        })
        .catch(err => {
          this.uploadError = err.response;
          this.currentStatus = STATUS_FAILED;
        });
    },

    isInvalidSize(currentSize) {
      if (this.size && currentSize > this.size) {       
        return false;
      }
      return true;
    },

    isInvalidWH(width, height) {      
      if (
        !this.width ||
        !this.height ||
        (width === this.width && height === this.height)
      ) {
        return false;
      } else {        
        return true;
      }
    },

    validateImage(file) {
      return new Promise(resolve => {
        let currentSize = file.size / 1024 / 1024;

        if (!this.isInvalidSize(currentSize)) {
          this.fileUploadMessages.push(
            `Arquivo: ${
              file.name
            }. Erro: Tamanho inválido (${currentSize.toFixed(
              2
            )} MB). Limite máximo é de ${this.size} MB`
          );
          resolve(null);
        } else {
          const fReader = new FileReader();          
          fReader.onload = () => {            
            resolve(file);            
          };
          fReader.readAsDataURL(file);
        }
      });
    },
    // fnExport(base64encodedstring) {
    //   var ua = window.navigator.userAgent;
    //   var msie = ua.indexOf("MSIE ");
    //   var sa;      
    //   if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    //     txtArea1.document.open("content type", "replace");
    //     txtArea1.document.write(base64encodedstring);
    //     txtArea1.document.close();
    //     txtArea1.focus();
    //     sa = txtArea1.document.execCommand(
    //       "SaveAs",
    //       true,
    //       reportname + ".extension"
    //     );
    //     console.log(sa);
    //   } else {        
    //     sa = window.open("data:content-type;base64," + base64encodedstring);
    //   }
    //   return sa;
    // },
    openImage(item) {
      window.open(this.$app.api + item.url, "_blank");
    },
    isBase64(url) {
      if (url.startsWith("data:"))
        return true;

      return false;
    },
    filesChange(fieldName, fileList) {
      this.fileUploadMessages = [];
      if (!fileList.length) return;

      const formData = new FormData();
      let hasInvalidSize = false;
      let hasInvalidWH = false;

      var promises = Array.from(Array(fileList.length).keys()).map(x =>
        this.validateImage(fileList[x]).then(img => {
          if (img !== null) formData.append(fieldName, img, img.name);
        })
      );

      Promise.all(promises).then(() => {
        if (formData.getAll("photos").length > 0) this.save(formData);

        if (this.fileUploadMessages.length > 0) {
          this.openDialog({
            messages: this.fileUploadMessages,
            alert: AlertType.ALERTA
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  // min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 30px 0;
}
</style>